import { Col, Form, Input, Row } from 'antd'
import FileSelect from '../elements/FileSelect'
import FormSectionTitle from '../elements/FormSectionTitle'
import withSort from '../elements/HOC/withSort'
import withSpinning from '../elements/HOC/withSpinning'
import CustomDebounceSelect from '../elements/Select/CustomDebounceSelect'
import withUrlFetch from '../elements/Select/withUrlFetch'
import { get } from 'lodash'
import { defaultFormItemLayout, fullWidthFormItemLayout, rules } from '../modules/FormItems'
import React, { Fragment } from 'react'
import { compose } from 'recompose'

const { TextArea } = Input

function QADetails (props) {
  const { getFieldDecorator, getFieldValue, doc } = props

  return (
    <Fragment>
      <FormSectionTitle title={'Q A Details'}/>
      <Row>
        <FileSelect
          {...{
            doc,
            getFieldValue,
            getFieldDecorator,
            acc: 'file',
            label: 'QA Report',
          }}
        />
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Prepared By">
            {getFieldDecorator(`preparedBy._id`, {
              initialValue: get(doc, `preparedBy._id`),
              rules: rules.select,
            })(<IndividualSelect keyAtr={'_id'} valueAtr={'fn'} style={{ width: '100%' }}/>)}
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label="Comment">
            {getFieldDecorator('comment', {
              initialValue: get(doc, 'comment'),
            })(<TextArea rows={7}/>)}
          </Form.Item>
        </Col>
      </Row>
    </Fragment>
  )
}

const IndividualSelect = compose(
  withUrlFetch({
    name: 'corporates',
    url: 'corporates/members',
    cache: true,
    forceFetch: false,
  }),
  withSpinning,
  withSort,
)(CustomDebounceSelect)

export default QADetails
